import { render, staticRenderFns } from "./CompCreateUser.vue?vue&type=template&id=184a0404&scoped=true"
import script from "./CompCreateUser.vue?vue&type=script&lang=js"
export * from "./CompCreateUser.vue?vue&type=script&lang=js"
import style0 from "./CompCreateUser.vue?vue&type=style&index=0&id=184a0404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184a0404",
  null
  
)

export default component.exports